import { Component, ViewChild, Injector, Output, EventEmitter, OnInit, ElementRef } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { CompaniesServiceProxy, CreateOrEditCompanyDto } from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';
import { DateTime } from 'luxon';
import { ActivatedRoute, Router } from '@angular/router';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { Observable } from '@node_modules/rxjs';
import { BreadcrumbItem, SubHeaderComponent } from '@app/shared/common/sub-header/sub-header.component';

import { DateTimeService } from '@app/shared/common/timing/date-time.service';

@Component({
    templateUrl: './create-or-edit-company.component.html',
    animations: [appModuleAnimation()],
    standalone: false,
})
export class CreateOrEditCompanyComponent extends AppComponentBase implements OnInit {
    active = false;
    saving = false;

    company: CreateOrEditCompanyDto = new CreateOrEditCompanyDto();

    breadcrumbs: BreadcrumbItem[] = [
        new BreadcrumbItem(this.l('Company'), '/app/master/companies'),
        new BreadcrumbItem(this.l('Entity_Name_Plural_Here') + '' + this.l('Details')),
    ];

    constructor(
        injector: Injector,
        private _activatedRoute: ActivatedRoute,
        private _companiesServiceProxy: CompaniesServiceProxy,
        private _router: Router,
        private _dateTimeService: DateTimeService,
    ) {
        super(injector);
    }

    ngOnInit(): void {
        this.show(this._activatedRoute.snapshot.queryParams['id']);
    }

    show(companyId?: number): void {
        if (!companyId) {
            this.company = new CreateOrEditCompanyDto();
            this.company.id = companyId;

            this.active = true;
        } else {
            this._companiesServiceProxy.getCompanyForEdit(companyId).subscribe((result) => {
                this.company = result.company;

                this.active = true;
            });
        }
    }

    save(): void {
        this.saving = true;

        this._companiesServiceProxy
            .createOrEdit(this.company)
            .pipe(
                finalize(() => {
                    this.saving = false;
                }),
            )
            .subscribe((x) => {
                this.saving = false;
                this.notify.info(this.l('SavedSuccessfully'));
                this._router.navigate(['/app/master/companies']);
            });
    }

    saveAndNew(): void {
        this.saving = true;

        this._companiesServiceProxy
            .createOrEdit(this.company)
            .pipe(
                finalize(() => {
                    this.saving = false;
                }),
            )
            .subscribe((x) => {
                this.saving = false;
                this.notify.info(this.l('SavedSuccessfully'));
                this.company = new CreateOrEditCompanyDto();
            });
    }

    goBack(): void{
        this._router.navigate(['/app/master/companies']);
    }
}
